__turbopack_context__.v({
  "app_light_theme": "expandable-radio-group-module-scss-module__24I_mq__app_light_theme",
  "group": "expandable-radio-group-module-scss-module__24I_mq__group",
  "radioButton": "expandable-radio-group-module-scss-module__24I_mq__radioButton",
});
